import { Button, Image, message, Modal, notification, Popover, Progress, Radio, Select, Space, Table, Upload } from "antd"
import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import Utils from "@utils/utils"
import styles from "./index.module.scss"
import API, { commonApiInvoker } from "@api/api";
import { useDrag, useDrop, useDragLayer } from 'react-dnd';
import { InfoCircleOutlined, MinusCircleFilled } from '@ant-design/icons';
import Iconfont from '@utils/Iconfont';
const _ = require('lodash')

const GOODS_TYPE = {
    CONSIGNMENT: "consignment", // 寄拍
    NON_CONSIGNMENT: "non_consignment" // 普通
}

const UPLOAD_TYPE = {
    CLOTH_TOP: "cloth_top",
    MODEL: "model",
    DIRECTORY_ONLY: "directory_only"
}

const BatchAdd = (props) => {
    const {
        // merchantId,
        // merchantName,
        goodsType=GOODS_TYPE.NON_CONSIGNMENT, // GOODS_TYPE.NON_CONSIGNMENT-普通商品; GOODS_TYPE.CONSIGNMENT-寄拍商品
        onOk,
        onCancel,
    } = props
    const [modal, modalContextHolder] = Modal.useModal();
    const [api, contextHolder] = notification.useNotification();
    const uploadTypeRef = useRef(UPLOAD_TYPE.MODEL)
    const [uploadType, setUploadType] = useState(UPLOAD_TYPE.MODEL)
    const deliveryVersionRef = useRef() // 交付批次   
    // const [dataSource, setDataSource] = useState(sessionStorage.getItem('skuList') ? JSON.parse(sessionStorage.getItem('skuList')) : [])
    const [dataSource, setDataSource] = useState([])
    const [loading, setLoading] = useState(false)
    const [uploading, setUploading] = useState(false)
    const uploadAbort = useRef()
    const [uploadTotal, setUploadTotal] = useState(0)
    const [uploadSuccess, setUploadSuccess] = useState(0)
    const uploadProgress = useMemo(() => {
        if (uploadTotal == 0) return 0
        return Math.floor(uploadSuccess / uploadTotal * 100)
    }, [uploadTotal, uploadSuccess])
    useEffect(() => {
        return () => {
            uploadAbort.current?.abort()
        }
    }, [])

    // useEffect(() => {
    //     if (dataSource.length == 0) sessionStorage.removeItem('skuList')
    //     else sessionStorage.setItem('skuList', JSON.stringify(dataSource))
    // }, [dataSource])

    // 开始录入
    const handleSubmit = async () => {
        try {
            setLoading(true)
            // if (!merchantId || !merchantName) {
            //     message.warning("请选择客户名称")
            //     return
            // }
            if (!deliveryVersionRef.current) {
                message.warning("交付批次为空，请重新上传")
                return
            }
            if (uploadType != UPLOAD_TYPE.DIRECTORY_ONLY) { // 仅录入货号：忽略图片
                // const skuImagesIsEmpty = dataSource.find(item => item.skuImages.length == 0)
                // if (skuImagesIsEmpty) {
                //     message.warning(`${skuImagesIsEmpty.skuCode} 请至少上传一张源素材`)
                //     return
                // }
                if (goodsType == GOODS_TYPE.CONSIGNMENT) {
                    const skuImagesNotOne = dataSource.find(item => item.skuImages.length > 1)
                    if (skuImagesNotOne) {
                        message.warning(`${skuImagesNotOne.skuCode} 寄拍商品只能上传一张源素材`)
                        return
                    }
                }
            }
            const skuList = dataSource.map(item => {
                return {
                    skuCode: item.skuCode,
                    deliveryVersion: deliveryVersionRef.current,
                    skuImages: item.skuImages.map((item2, index) => index == 0 ? ({
                        ...item2,
                        name: item.skuCode
                    }) :
                    ({...item2})),
                    matchImages: item.matchImages,
                    refImages: item.refImages
                }
            })
            onOk(skuList)
            // const res = await commonApiInvoker(API.batchCreateMerchantRequirementSku({
            //     merchantId: merchantId,
            //     merchantName: merchantName,
            //     skuList: skuList,
            //     virtual: goodsType == GOODS_TYPE.CONSIGNMENT ? 0 : 1,
            // }), null, true)
            // const {failed, succeeded, existed} = res
            // let confirmed = false
            // if (existed.length > 0) {
            //     confirmed = await modal.confirm({
            //         content: (
            //             <div>
            //                 <span>以下商品货号已存在关联任务，确定重复作图？</span>
            //                 <ul>
            //                 {existed.map(item => (
            //                     <li>{item.skuCode}</li>
            //                 ))}
            //                 </ul>
            //             </div>
            //         )
            //     })
            // }
            // const submitList = confirmed ? [...succeeded, ...existed] : succeeded
            // onOk(submitList)
            // const failedLength = Object.keys(failed).length
            // if (failedLength === 0) {
            //     if (submitList.length > 0) message.success('录入成功')
            //     else message.success('未录入任何商品')
            //     onCancel()
            // } else {
            //     let result = '';
            //     for (const [key, value] of Object.entries(failed)) {
            //         result += `${key}: ${value}\n`;
            //     }
            //     Modal.info({
            //         title: "出错的项",
            //         width: 800,
            //         content: (
            //             <div>
            //                 <pre style={{ lineHeight: '2', color: '#FF6666' }}>{result}</pre>
            //                 <p style={{ color: '#00D32A' }}>未显示的项已成功创建</p>
            //             </div>
            //         ),
            //         okText: "确认",
            //         onOk: () => {
            //             if (succeeded.length == 0) {
            //                 // 没有成功的数据，不需要关闭抽屉
            //             } else {
            //                 onCancel()
            //             }
            //         }
            //     })
            // }
        } catch (err) {
            console.error(err)
            message.warning(err.message)
        } finally {
            setLoading(false)
        }
    }
    // 全部清空
    const cleanClick = () => {
        setDataSource([])
        deliveryVersionRef.current = null
    }
    // 需求类型是否可用
    const uploadTypeDisabled = useMemo(() => {
        return dataSource.length > 0
    }, [dataSource])
    // 需求类型
    const handleUploadTypeChange = (e) => {
        uploadTypeRef.current = e.target.value
        setUploadType(e.target.value)
        setDataSource([])
        deliveryVersionRef.current = null
    }
    // 校验文件列表
    const validateFileList = (fileList) => {
        const errors = [];
        const validTypes = ['image/png', 'image/jpeg', 'image/webp', 'image/avif'];
        // 校验图片大小
        const MAX_IMAGE_SIZE = 50 * 1024 * 1024;

        // 过滤出符合规则的文件
        // 最大的文件层级，仅筛选3/4级目录
        const maxDirDeep = fileList.reduce((pre, curr) => {
            const parts = curr.relativePath.split('/')
            const deep = parts.length
            if (deep < 3 || deep > 4) return pre
            return Math.max(deep, pre)
        }, 0)
        const filteredFiles = fileList.filter(item => {
            const file = item.file
            const fileType = file.type;
            const fileSize = file.size;
            const parts = item.relativePath.split('/');
            // 检查文件类型
            if (!validTypes.includes(fileType)) {
                errors.push(`文件类型错误：${item.relativePath}`);
                return false;
            }
            // 检查文件大小
            if (fileSize > MAX_IMAGE_SIZE) {
                errors.push(`图片大小超过${MAX_IMAGE_SIZE / 1024 / 1024}MB：${item.relativePath}`);
                return false;
            }
            // 检查文件夹结构
            if (parts.length < 3 || parts.length > 4) {
                errors.push(`文件位置错误：${item.relativePath}`);
                return false;
            }
            // 存在3级目录时，不录入2级目录下面的图片
            if (parts.length != maxDirDeep) {
                errors.push(`文件位置错误：${item.relativePath}`);
                return false;
            }
            return true;
        });

        return {
            filteredFiles,
            errors: errors.length > 0 ? errors.join("\n") : null
        };
    };
    // 校验文件列表-仅录入货号
    const validateFileList2 = (fileList) => {
        console.log('fileList', fileList)
        const errors = [];
        const filteredFiles = fileList.map(item => {
            const parts = item.relativePath.split('/');
            if (parts.length > 4) {
                return {
                    ...item,
                    relativePath: parts.slice(0, 4).join('/')
                }
            }
            return item
        }).filter(item => {
            const parts = item.relativePath.split('/');
            // 检查文件夹结构
            if (parts.length < 3) {
                errors.push(`文件位置错误：${item.relativePath}`);
                return false;
            }
            return true;
        })
        return {
            filteredFiles,
            errors: errors.length > 0 ? errors.join("\n") : null
        };
    }
    // 上传文件夹校验
    const checkFolder = (fileList) => {
        try {
            // 校验文件列表
            const { filteredFiles, errors } = uploadTypeRef.current == UPLOAD_TYPE.DIRECTORY_ONLY ? 
                validateFileList2(fileList) :
                validateFileList(fileList);

            // 获取一级目录名
            const deliveryVersion = filteredFiles.length > 0
                ? filteredFiles[0].relativePath.split("/")[0]
                : null;

            if (filteredFiles.length === 0) {
                return {
                    success: false,
                    filteredFiles: [],
                    errors: errors || '没有符合要求的有效文件',
                    deliveryVersion: null
                };
            }

            return {
                success: errors ? false : true,
                filteredFiles,
                errors,
                deliveryVersion
            };
        } catch (err) {
            message.warning(err.message);
            return {
                success: false,
                filteredFiles: [],
                errors: err.message,
                deliveryVersion: null
            };
        }
    }
    // 将file转为{name, url, skuCode, deliveryVersion}格式对象
    const formatFile = async (item) => {
        const file = item.file
        const parts = item.relativePath.split("/");
        const deliveryVersion = parts[0]; // 交付批次
        let skuCode, filename
        if (parts.length == 3) {
            skuCode = Utils.sanitizeString(parts[1])
            const name = parts[2]
            filename = name.split('.').slice(0, -1).join('.');
        } else {
            skuCode = `${Utils.sanitizeString(parts[1])}-${Utils.sanitizeString(parts[2])}`
            const name = parts[3]
            filename = name.split('.').slice(0, -1).join('.');
        }

        // 仅录入货号不上传图片
        const url =
            uploadTypeRef.current == UPLOAD_TYPE.DIRECTORY_ONLY ? "" :
            await Utils.uploadFile(file, true, uploadAbort.current?.signal);

        if (uploadTypeRef.current == UPLOAD_TYPE.DIRECTORY_ONLY) {
            return { name: filename, url: url, skuCode, deliveryVersion }
        } else {
            if (!url) return null
            return { name: filename, url: url, skuCode, deliveryVersion }
        }
    }
    // 处理上传图片
    const processUploadFiles = async (files) => {
        if (!files.length) return
        // 过滤出Thumbs.db文件
        files = files.filter(item => {
            const filename = item.file.name
            return !/Thumbs\.db/.test(filename)
        })
        const checkFolderRes = checkFolder(files)

        // 判断二次上传一级目录必须一致
        // if (deliveryVersionRef.current) {
        //     if (deliveryVersionRef.current !== checkFolderRes?.deliveryVersion) {
        //         message.warning('前后批次（一级目录）不一致，请修改后上传！', 5)
        //         return false
        //     }
        // }
        if (checkFolderRes?.errors) {
            api.warning({
                message: '已过滤的错误项，请确认：',
                duration: null,
                description: (
                    <div style={{ maxHeight: '60vh', overflow: 'auto' }}>
                        <pre style={{
                            whiteSpace: 'pre-wrap',
                            margin: 0,
                            fontFamily: 'inherit'
                        }}>
                            {checkFolderRes?.errors}
                        </pre>
                    </div>
                ),
            })
        }

        setUploadTotal(checkFolderRes?.filteredFiles?.length||0)
        let fileList = await Promise.all(checkFolderRes?.filteredFiles.map(item => {
            return formatFile(item).then(res => {
                setUploadSuccess(pre => pre+1)
                return res
            })
        }))
        fileList = fileList.filter(item => item)

        // 为相同的skuCode分配同一个uid
        const uidMap = {}
        fileList = fileList.map(item => {
            const {skuCode} = item
            if (!uidMap[skuCode]) {
                uidMap[skuCode] = Utils.genUid()
            }
            return {...item, uid: uidMap[skuCode]}
        })
        
        for (let item of fileList) {
            const {uid, name, url, skuCode, deliveryVersion} = item
            // 普通 goodsType=GOODS_TYPE.NON_CONSIGNMENT
            //  -服装上身：所有图——>参考图
            //  -换模特/背景：所有图——>源素材
            // 寄拍 goodsType=GOODS_TYPE.CONSIGNMENT
            //  -默认取第一张为源素材，其余作为参考图
            setDataSource(pre => {
                const temp = [...pre]
                const skuItem = temp.find(item => item.uid == uid)
                if (goodsType == GOODS_TYPE.CONSIGNMENT) { // 寄拍,默认取第一张为源素材，其余作为参考图
                    if (uploadTypeRef.current == UPLOAD_TYPE.DIRECTORY_ONLY) { // 仅录入货号：不处理图片
                        if (skuItem) {}
                        else {
                            const skuItem = {
                                uid,
                                skuCode,
                                deliveryVersion,
                                skuImages: [], // 源素材
                                matchImages: [], // 搭配图
                                refImages: [], // 参考图
                            }
                            temp.push(skuItem)
                        }
                    } else {
                        if (skuItem) {
                            if (skuItem.skuImages.length > 0) {
                                skuItem.refImages = [...skuItem.refImages, {url, name}]
                            } else {
                                skuItem.skuImages = [{url, name}]
                            }
                        } else {
                            const skuItem = {
                                uid,
                                skuCode,
                                deliveryVersion,
                                skuImages: [{url, name}], // 源素材
                                matchImages: [], // 搭配图
                                refImages: [], // 参考图
                            }
                            temp.push(skuItem)
                        }
                    }
                } else { // 普通
                    if (uploadTypeRef.current == UPLOAD_TYPE.CLOTH_TOP) { // 衣服图上身：所有图——>参考图
                        if (skuItem) {
                            skuItem.refImages = [...skuItem.refImages, {url, name}]
                        } else {
                            const skuItem = {
                                uid,
                                skuCode,
                                deliveryVersion,
                                skuImages: [], // 源素材
                                matchImages: [], // 搭配图
                                refImages: [{url, name}], // 参考图
                            }
                            temp.push(skuItem)
                        }
                    } else if (uploadTypeRef.current == UPLOAD_TYPE.MODEL) { // 换模特/背景：所有图——>源素材
                        if (skuItem) {
                            skuItem.skuImages = [...skuItem.skuImages, {url, name}]
                        } else {
                            const skuItem = {
                                uid,
                                skuCode,
                                deliveryVersion,
                                skuImages: [{url, name}], // 源素材
                                matchImages: [], // 搭配图
                                refImages: [], // 参考图
                            }
                            temp.push(skuItem)
                        }
                    } else if (uploadTypeRef.current == UPLOAD_TYPE.DIRECTORY_ONLY) { // 仅录入货号：不处理图片
                        if (skuItem) {}
                        else {
                            const skuItem = {
                                uid,
                                skuCode,
                                deliveryVersion,
                                skuImages: [], // 源素材
                                matchImages: [], // 搭配图
                                refImages: [], // 参考图
                            }
                            temp.push(skuItem)
                        }
                    }
                }
                if (temp.length == 0) deliveryVersionRef.current = null
                else if (!deliveryVersionRef.current) deliveryVersionRef.current = deliveryVersion
                return [...temp]
            })
        }
    }
    const uploadDebounce = useCallback(_.debounce((file, fileList) => {
        // 将上传文件组合为file+relativePath
        const files = Array.from(fileList)
            .filter(item => { // 过滤掉文件路径中存在以点开头的文件夹/文件
                const name = item.name
                const webkitRelativePath = item.webkitRelativePath
                const parts = webkitRelativePath.split(/[\\/]/);
                if (name.startsWith('.') || parts.some(name => name.startsWith('.'))) return false
                return true
            }).map(file => ({
                file: file,
                relativePath: file.webkitRelativePath
            }));
        uploadAbort.current = new AbortController();
        setUploadSuccess(0)
        setUploadTotal(0)
        setUploading(true)
        processUploadFiles(files).catch(err => {
            console.error(err)
        }).finally(() => {
            setUploading(false)
        })
    }, 500), [])
    const handleUpload = (file, fileList) => {
        uploadDebounce(file, fileList)
        return false
    }

    // 删除sku
    const handleRemoveSku = (record) => {
        Modal.confirm({
            title: "确定删除这个sku？",
            onOk: () => setDataSource(pre => {
                const temp = [...pre]
                const res = temp.filter(item => item.uid !== record.uid)
                if (res.length == 0) deliveryVersionRef.current = null
                return res
            })
        })
    }

    // 删除sku的图片
    const handleRemoveImage = (record, uid, type) => {
        setDataSource(pre => {
            const temp = [...pre]
            for (let item of temp) {
                if (item.uid == uid) {
                    const index = item[type].findIndex(i => i.url == record.url)
                    item[type].splice(index, 1)
                    return temp
                }
            }
            return temp
        })
    }

    // 移动图片
    const handleDrop = (record, rowId, fromType, toType) => {
        setDataSource(pre => {
            const temp = [...pre]
            for (let item of temp) {
                if (item.uid == rowId) {
                    const fromList = item[fromType]
                    const toList = item[toType]
                    fromList.splice(record.index, 1)
                    toList.push({
                        name: record.name,
                        url: record.url
                    })
                    item[fromType] = fromList
                    item[toType] = toList
                    return temp
                }
            }
            return temp
        })
    }

    const columns = [{
        title: '货号',
        dataIndex: 'skuCode',
        key: 'skuCode',
        width: 250,
    }, {
        title: '源素材',
        dataIndex: 'skuImages',
        key: 'skuImages',
        minWidth: 200,
        width: 400,
        hidden: uploadType == UPLOAD_TYPE.DIRECTORY_ONLY,
        render: (text, record) => (
            <ImageList rowId={record.uid} type="skuImages" onDrop={handleDrop}>
            {
                text.map((item, index) => (
                    <ImageItem
                        key={item.url}
                        index={index}
                        rowId={record.uid}
                        type="skuImages"
                        url={item.url}
                        name={item.name}
                        displayName={index == 0 ? record.skuCode : item.name}
                        onRemove={() => handleRemoveImage(item, record.uid, "skuImages")}
                    />
                ))
            }
            </ImageList>
        )
    }, {
        title: '搭配图',
        dataIndex: 'matchImages',
        key: 'matchImages',
        minWidth: 200,
        width: 400,
        hidden: goodsType != GOODS_TYPE.NON_CONSIGNMENT || uploadType == UPLOAD_TYPE.DIRECTORY_ONLY,
        render: (text, record) => (
            <ImageList rowId={record.uid} type="matchImages" onDrop={handleDrop}>
            {
                text.map((item, index) => (
                    <ImageItem
                        key={item.url}
                        index={index}
                        rowId={record.uid}
                        type="matchImages"
                        url={item.url}
                        name={item.name}
                        onRemove={() => handleRemoveImage(item, record.uid, "matchImages")}
                    />
                ))
            }
            </ImageList>
        )
    }, {
        title: '参考图',
        dataIndex: 'refImages',
        key: 'refImages',
        minWidth: 200,
        width: 400,
        hidden: uploadType == UPLOAD_TYPE.DIRECTORY_ONLY,
        render: (text, record) => (
            <ImageList rowId={record.uid} type="refImages" onDrop={handleDrop}>
            {
                text.map((item, index) => (
                    <ImageItem
                        key={item.url}
                        index={index}
                        rowId={record.uid}
                        type="refImages"
                        url={item.url}
                        name={item.name}
                        onRemove={() => handleRemoveImage(item, record.uid, "refImages")}
                    />
                ))
            }
            </ImageList>
        )
    }, {
        key: "empty",
    }, {
        key: "acition",
        title: "操作",
        width: 200,
        fixed: 'right',
        render: (_, record) => (
            <Space>
                <Button danger type="link" onClick={() => handleRemoveSku(record)}>删除</Button>
            </Space>
        )
    }].filter(item => !!item)

    return (
        <div className={styles.Contianer}>
            {modalContextHolder}
            {contextHolder}
            <div className={styles.Header}>
            {
                dataSource.length > 0 ?
                <Space size={8}>
                    <span>上传图片</span>
                    <Upload.Dragger
                        className={styles.UploadBtn}
                        directory
                        showUploadList={false}
                        beforeUpload={handleUpload}
                        disabled={uploading}
                    >
                        <Button loading={uploading}>点击或拖拽上传文件夹</Button>
                    </Upload.Dragger>
                </Space> :
                <div className={styles.Tips}>
                    <span>上传要求</span>
                    <ul>
                        <Popover
                            content={(
                                <div className={styles.popoverContent} >
                                    <img style={{ width: '550px', height: '484px' }} src={require('@assets/images/folderSample_3.png')} alt="" />
                                </div>
                            )}
                            trigger="hover"
                            arrow={false}
                            placement="bottomLeft"
                            align={{
                                offset: [280, -40],            // the offset sourceNode by 10px in x and 20px in y,
                                overflow: { adjustX: true, adjustY: true }, // auto adjust position when sourceNode is overflowed
                            }}
                        >
                            <li>
                                <span>单款单色的商品：按货号汇总</span>
                                <Iconfont type="icon-info" style={{ fontSize: 16 }} />
                            </li>
                        </Popover>
                        <Popover
                            content={(
                                <div className={styles.popoverContent} >
                                    <img style={{ width: '550px', height: '632px' }} src={require('@assets/images/folderSample_4.png')} alt="" />
                                </div>
                            )}
                            trigger="hover"
                            arrow={false}
                            placement="bottomLeft"
                            align={{
                                offset: [400, -40],            // the offset sourceNode by 10px in x and 20px in y,
                                overflow: { adjustX: true, adjustY: true }, // auto adjust position when sourceNode is overflowed
                            }}
                        >
                            <li>
                                <span>同款多色的商品：按货号-颜色分别整理后汇总</span>
                                <Iconfont type="icon-info" style={{ fontSize: 16 }} />
                            </li>
                        </Popover>
                    </ul>
                </div>
            }
            </div>
            <div className={styles.Body}>
            {
                dataSource.length > 0 ?
                <Table
                    size="small"
                    className="customTable"
                    rowKey={"uid"}
                    dataSource={dataSource}
                    columns={columns}
                    pagination={false}
                    scroll={{
                        x: 'max-content',
                        y: `max-content`,
                    }}
                /> : 
                <Upload.Dragger
                    className={styles.UploadCard}
                    directory
                    showUploadList={false}
                    beforeUpload={handleUpload}
                    disabled={uploading}
                >
                    <div className={styles.UploadBox}>
                        <Iconfont type="icon-upload" style={{ fontSize: 32 }} />
                        <span style={{fontSize: 14}}>点击上传或拖拽文件至此</span>
                        <Button style={{width: 216, height: 48}} type="primary">选择文件夹</Button>
                        <p style={{fontSize: 12, color: "#99A1AF"}}>支持JPG/PNG/WEBP/AVIF格式,最大图片尺寸50MB</p>
                    </div>
                </Upload.Dragger>
            }
            </div>
            <div className={styles.Footer}>
                <Button
                    style={{ width: '300px' }}
                    loading={loading}
                    disabled={dataSource.length == 0 || uploading}
                    type="primary"
                    onClick={handleSubmit}>
                    开始录入
                </Button>
                <Button
                    type="link"
                    disabled={dataSource.length === 0 || uploading}
                    onClick={cleanClick}
                >
                    全部清空
                </Button>
            </div>
            {uploading &&
            <div className={styles.UploadProgress}>
                <Progress percent={uploadProgress} format={() => `${uploadSuccess}/${uploadTotal}`} />
                <Button danger type="primary" onClick={() => uploadAbort.current?.abort()}>停止</Button>
            </div>}
        </div>
    )
}

export default BatchAdd

function ImageList(props) {
    const {
        rowId,
        type,
        onDrop,
        children
    } = props
    const ref = useRef(null)

    const [{hovered}, drop] = useDrop({
        accept: `${rowId}`,
        hover: (item, monitor) => {},
        canDrop: () => true,
        drop: (item, monitor) => {
            if (!monitor.canDrop()) return
            console.log('drop', item)
            const dragType = item.type
            const dropType = type
            if (dragType === dropType) return // 如果回到自己的坑，那就什么都不做
            onDrop(item, rowId, dragType, dropType)
        },
        collect: (monitor) => ({
            hovered: monitor.isOver()
        })
    })

    return (
        <div className={`${styles.ImageList} ${hovered && styles.hovered}`} ref={drop(ref)}>
        {children}
        </div>
    )
}

function ImageItem(props) {
    const {url, name, displayName, index, rowId, type, onRemove} = props

    const ref = useRef(null)
    const [{ isDragging }, drag, preview] = useDrag({
        type: `${rowId}`,
        item: {index, url, name, type},
        canDrag: () => true,
        end: (item, monitor) => {},
        isDragging: (monitor) => index === monitor.getItem().index,
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    })

    return (
        <div className={styles.ImageItem} ref={drag(ref)}>
            <Image src={Utils.getImgThumbnail(url)} preview={false} fallback={require('@assets/images/fallback.png')} />
            <span className={styles.ImageName}>{displayName||name}</span>
            <MinusCircleFilled className={styles.RemoveTrigger} onClick={onRemove} />
        </div>
    )
}